import { ITitleAssetUrlDTO } from '../../api/assets.dao';
import { RequestContentType } from '../api-client';

export const getFileTypeFromName = (reportFile: File) => {
    const splittedName = reportFile.name.split('.');
    return splittedName.length > 1 ? splittedName[splittedName.length - 1].toLowerCase() : '';
};

const EXTENSION_CONTENT_TYPES: Record<string, RequestContentType> = {
    jpg: RequestContentType.imgJpg,
    jpeg: RequestContentType.imgJpeg,
    png: RequestContentType.imgPng,
    gif: RequestContentType.imgGif,
    svg: RequestContentType.imgSvg,
    tif: RequestContentType.imgTiff,
    tiff: RequestContentType.imgTiff,
    woff: RequestContentType.woff,
    m4a: RequestContentType.m4a,
    ogg: RequestContentType.ogg,
    oga: RequestContentType.ogg,
    flac: RequestContentType.flac,
    aac: RequestContentType.aac,
    webm: RequestContentType.audioWebm,
    mpeg: RequestContentType.mpeg,
    mp3: RequestContentType.mp3,
    wav: RequestContentType.wav,
    mp4: RequestContentType.mp4,
    mov: RequestContentType.mov,
    zip: RequestContentType.zip,
    csv: RequestContentType.csv,
    html: RequestContentType.html,
    txt: RequestContentType.txt,
    pdf: RequestContentType.pdf,
    ics: RequestContentType.ics,
    msg: RequestContentType.msg,
    doc: RequestContentType.doc,
    docx: RequestContentType.docx,
    xls: RequestContentType.xls,
    xlsx: RequestContentType.xlsx,
    ppt: RequestContentType.ppt,
    pptx: RequestContentType.pptx,
    ttf: RequestContentType.ttf,
    otf: RequestContentType.otf,
    woff2: RequestContentType.woff2,
    eot: RequestContentType.eot,
};

export const getContentTypeFromName = (file: File): RequestContentType | undefined => {
    return EXTENSION_CONTENT_TYPES[getFileTypeFromName(file)];
};

export const isFilePublic = (asset: ITitleAssetUrlDTO): boolean => {
    return !!asset.publicDownloadLink;
};
